export const CREATE_PRODUCTION_PURCHASE = 'CREATE_PRODUCTION_PURCHASE';
export const GET_PRODUCTION_PURCHASES = 'GET_PRODUCTION_PURCHASES';
export const UPDATE_PRODUCTION_PURCHASE = 'UPDATE_PRODUCTION_PURCHASE';
export const DELETE_PRODUCTION_PURCHASE = 'DELETE_PRODUCTION_PURCHASE';
export const PRODUCTION_PURCHASE_REQUEST = 'PRODUCTION_PURCHASE_REQUEST';
export const PRODUCTION_PURCHASE_FAILURE = 'PRODUCTION_PURCHASE_FAILURE';
